import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsLoadingRanks, makeSelectRanks } from "./selectors"
import { getListRanksWatcher } from "./actions"

import "./index.less"
import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../../../utils/storage"
import AnalysisSegment from "../../../../../containers/Report/Home/Components/AnalysisSegment"
/*
import { Spin } from "antd"
*/

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetAnalysisSegmentTeam(props) {
  const [measureID] = useState(props.idMeasure)
  const prevMeasureID = usePreviousMeasureID(measureID)

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    }
  }, [props.idMeasure])

  const initGetData = async () => {
    const { idMeasure, getListRanks, measureGeneral, selectedSegment } = props
    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_segment: selectedSegment,
      },
      id_segment: selectedSegment,
    }
    getListRanks(params)
  }

  return (
    <AnalysisSegment
      ranks={props.ranks}
      measure={props.idMeasure}
      isLoading={props.isLoadingRanks}
      view_leader
      selectedSegment={props.selectedSegment}
    />
  )
}

WidgetAnalysisSegmentTeam.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  isLoadingRanks: PropTypes.bool,
  getListRanks: PropTypes.func,
  ranks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

const mapStateToProps = createStructuredSelector({
  isLoadingRanks: makeSelectIsLoadingRanks(),
  ranks: makeSelectRanks(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListRanks: (params) => dispatch(getListRanksWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetAnalysisSegmentTeam", reducer })
const withSaga = injectSaga({ key: "widgetAnalysisSegmentTeam", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetAnalysisSegmentTeam)
